export default __webpack_public_path__ + "static/drawarrow-9174e75082f85c30df4cbaaacf956f26.png";